/**
 * Modelo Padrão de Instância Logada.
 */
export class InstanceCana {

    instance: string;
    nameInstance: string;

    constructor() { }

}